// The design profile values for the Vue 2 admin (Jest there cannot import TS).
// Must equal PROFILE_VALUES in src/editor-v2/model/section/ai/profile.ts (profile.spec.ts checks it).
export default {
  headings: ['calm', 'strong', 'striking'],
  text_on_image: ['yes', 'sparse', 'never'],
  color_surfaces: ['few', 'some', 'many'],
  image_weight: ['images', 'balanced', 'text'],
};
